import type { ApiResponse } from '@shared/api'

import { useAdminRoutes } from '@shared/lib/routes'

import { useDisciplineStore } from '../model/store'

interface DisciplineCustomerGoApiOptions {
  customerId: string | number
}

/** The "Goal" badge of the discipline title and the Kanban log customer badge need `is_go` and the premium label,
 *  which only `customers.details` carries: the customer nested in `disciplines.details` is the simple shape without
 *  them. A failure only hides the badges, so it stays silent. */
export const useDisciplineCustomerGoApi = async (options: DisciplineCustomerGoApiOptions): Promise<void> => {
  const { $axios } = useNuxtApp()
  const disciplineStore = useDisciplineStore()

  const url = useAdminRoutes('admin.disciplines.api.customer-details', { customer_id: options.customerId })

  disciplineStore.setCustomerGo(false)
  disciplineStore.setCustomerPremium(false)

  if (!url) return

  try {
    const { data } = await $axios.get<ApiResponse>(url)
    disciplineStore.setCustomerGo(data.data?.is_go === true)
    disciplineStore.setCustomerPremium(data.data?.labels?.is_premium === true)
  } catch (err: unknown) {
    console.error(err)
  }
}
